import { render } from "./ViewEvent.vue?vue&type=template&id=d9278b34"
import script from "./ViewEvent.vue?vue&type=script&lang=js"
export * from "./ViewEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__